const boxStyle =
  "flex items-center mb-1 gap-2 rounded-lg py-2 px-3 cursor-pointer";

export type CheckBoxProps = {
  label?: string;
  onChange?: any;
  value?: boolean;
  isSpecial?: boolean;
  labelClassName?: string;
};

function CheckBox({
  label,
  onChange,
  value,
  isSpecial,
  labelClassName,
}: CheckBoxProps) {
  const inputStyle = isSpecial ? "text-secondary" : "text-primary-700";

  return (
    <div className={`${boxStyle}`} onClick={onChange}>
      <input
        type="checkbox"
        className={`h-4 w-4 rounded border-gray-300 focus:ring-0 focus:outline-none cursor-pointer bg-slate-200/60 ${inputStyle}`}
        checked={value}
        onChange={onChange}
      />
      <span className={`${labelClassName} text-black`}>{label}</span>
    </div>
  );
}

export default CheckBox;
